import sift from 'sift'

import buildQueryActivities from '@/plugins/axios-interceptors/build-query-activities.js'

const isBackupAppInterceptor = ({ $axios }) => {
  $axios.defaults.adapter = function (config) {
    let data

    if (config.url === 'current-user' || config.url === 'login') {
      data = {
        user: window.planfredOffline.currentuser,
      }
    } else if (config.url.match(/users\/[a-zA-Z0-9]*/)) {
      data = []
    } else if (config.url === 'projects') {
      data = [window.planfredOffline.project]
    } else if (config.url.match(/projects\/[a-zA-Z0-9]*/)) {
      // /projects/58b70a51e7b6b69c746e8df3
      data = window.planfredOffline.project
    } else if (config.url === 'plans' && config.params.projectid) {
      // /plans?projectid=581e0797cb495f0e200e9af0
      data = window.planfredOffline.plans
    } else if (config.url.match(/plans\/[a-zA-Z0-9]*/)) {
      // /plans/52f613570385b300006905ce
      if (config.url.match(/plans\/[a-zA-Z0-9]{24}\/activities/)) {
        const pathParams = config.url.split('/').filter(i => i)
        const planId = pathParams[1]

        // /tasks/581e0797cb495f0e200e9af0/activities
        data = window.planfredOffline.activities.filter(sift({
          $or: [
            {
              'log.plan._id': planId,
              action: {
                $in: [
                  'getplanrevisionpdf',
                  'getplanrevisiondwg',
                  'getapprovalcommentattachment',
                  'patchplantrash',
                ],
              },
            },
            {
              action: 'sendrevisionplan',
              'log.revisionsSent': {
                $elemMatch: {
                  'plan._id': planId,
                },
              },
            },
          ],
        }))
      } else {
        const planId = config.url.split('/')[1]
        data = window.planfredOffline[`plan_${planId}`]
      }
    } else if (config.url === 'documents' && config.params.projectid) {
      // /documents?projectid=581e0797cb495f0e200e9af0
      data = window.planfredOffline.documents
    } else if (config.url.match(/documents\/[a-zA-Z0-9]*/)) {
      // /documents/52f613570385b300006905ce
      if (config.url.match(/documents\/[a-zA-Z0-9]{24}\/activities/)) {
        const pathParams = config.url.split('/').filter(i => i)
        const documentId = pathParams[1]

        // /tasks/581e0797cb495f0e200e9af0/activities
        data = window.planfredOffline.activities.filter(sift({
          $or: [
            {
              'log.document._id': documentId,
              action: {
                $in: [
                  'getdocumentrevision',
                  'getdocumentapprovalcommentattachment',
                  'patchdocumenttrash',
                ],
              },
            },
            {
              action: 'sendrevisiondoc',
              'log.revisionsSent': {
                $elemMatch: {
                  'document._id': documentId,
                },
              },
            },
          ],
        }))
      } else {
        const documentId = config.url.split('/')[1]
        data = window.planfredOffline[`document_${documentId}`]
      }
    } else if (config.url === 'tasks' && config.params.projectid) {
      // /tasks?projectid=581e0797cb495f0e200e9af0
      data = window.planfredOffline.tasks
    } else if (config.url === 'tasks/latest-by-user' && config.params.projectid) {
      // /tasks/latest-by-user

      const taskList = window.planfredOffline.tasks && window.planfredOffline.tasks.list ? window.planfredOffline.tasks.list : []
      const taskListFilteredAndSorted = taskList
        .filter(task => {
          const reqUser = window.planfredOffline.currentuser

          return task.projectId === config.params.projectId && task.creatorUserId === reqUser._id
        })
        .sort((a, b) => new Date(b.created) - new Date(a.created))

      data = taskListFilteredAndSorted[0]
    } else if (config.url.match(/tasks\/[a-zA-Z0-9]{24}/)) {
      const pathParams = config.url.split('/').filter(i => i)
      const taskId = pathParams[1]

      if (config.url.match(/tasks\/[a-zA-Z0-9]{24}\/activities/)) {
        // /tasks/581e0797cb495f0e200e9af0/activities
        data = window.planfredOffline.activities.filter(sift({
          'log.task._id': taskId,
          'log.comment._id': {
            $exists: false,
          },
        }))
      } else if (config.url.match(/tasks\/[a-zA-Z0-9]{24}\/comments\/[a-zA-Z0-9]{24}\/activities/)) {
        // /tasks/581e0797cb495f0e200e9af0/comments/581e0797cb495f0e200e9aaa/activities
        const commentId = pathParams[3]
        data = window.planfredOffline.activities.filter(sift({
          'log.comment._id': commentId,
        }))
      } else {
        // /tasks/581e0797cb495f0e200e9af0
        data = window.planfredOffline[`task_${taskId}`]
      }
    } else if (config.url === 'location-layers' && config.params.projectid) {
      data = window.planfredOffline['location-layers']
    } else if (config.url === 'filters' && config.params.projectid && config.params.filterkeys) {
      // /filters?projectid=581e0797cb495f0e200e9af0&filterkeys=tasksListWebMain,tasksListWebDone
      // mock server side filters in backup app with empty object
      data = []
    } else if (config.url === 'filters' && config.params.projectid) {
      // /filters?projectid=581e0797cb495f0e200e9af0
      // mock server side filters in backup app with empty object
      data = []
    } else if (config.url.match(/activities\/[a-zA-Z0-9]*/)) {
      // /activities/52f613570385b300006905ce
      const activityId = config.url.split('/')[1]
      data = window.planfredOffline.activities.find(activity => activity._id === activityId)
      // New activities query with POST request
    } else if (config.url.match(/activities?/) && config.method === 'post') {
      const reqUser = window.planfredOffline.currentuser
      const project = window.planfredOffline.project
      const reqQuery = JSON.parse(config.data)

      const query = buildQueryActivities({
        reqUser,
        project,
        reqQuery,
      })

      data = window.planfredOffline.activities.filter(sift(query))
    } else {
      console.error(`No match for url "${config.url}"`)
    }

    return Promise.resolve({
      data: JSON.parse(JSON.stringify(data || {})),
      status: 200,
      statusText: 'OK',
      headers: {},
      config,
      request: {},
    })
  }
}

export default isBackupAppInterceptor
